import { CopyMoveFileParams, CopyMoveFolderParams } from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useCopyFile() {
  const { server } = useServer()
  const client = useQueryClient()
  return useMutation({
    mutationFn: copyFile,
    onSuccess: async (data, variables, context) => {
      if (variables.newChatGroupId) {
        await client.invalidateQueries({
          queryKey: keys.chatGroup(variables.newChatGroupId),
        })
      }
    },
  })

  async function copyFile({
    fileId,
    newParentFolderId,
    newChatGroupId,
  }: CopyMoveFileParams) {
    const queryParams = new URLSearchParams()
    if (newChatGroupId) {
      queryParams.append('new_chat_group_id', newChatGroupId)
    }
    if (newParentFolderId) {
      queryParams.append('new_parent_folder_id', newParentFolderId)
    }

    const url = `/v2/chat/repository/files/${fileId}/copy?${queryParams.toString()}`
    await server.put(url, {})
  }
}

export function useCopyFolder() {
  const { server } = useServer()
  const client = useQueryClient()
  return useMutation({
    mutationFn: copyFolder,
    onSuccess: async (data, variables, context) => {
      if (variables.newChatGroupId) {
        await client.invalidateQueries({
          queryKey: keys.chatGroup(variables.newChatGroupId),
        })
      }
    },
  })

  async function copyFolder({
    folderId,
    newParentFolderId,
    newChatGroupId,
  }: CopyMoveFolderParams) {
    const queryParams = new URLSearchParams()
    if (newChatGroupId) {
      queryParams.append('new_chat_group_id', newChatGroupId)
    }
    if (newParentFolderId) {
      queryParams.append('new_parent_folder_id', newParentFolderId)
    }
    const url = `/v2/chat/repository/folders/${folderId}/copy?${queryParams.toString()}`
    await server.put(url, {})
  }
}
